module.exports = __webpack_public_path__ + "media/images/FeaturesBG-Mobile-b0e70c56.png";